const types = {
  mutations: {
    SET_MY_TOPICS: 'SET_MY_TOPICS',
    SET_LATEST_TOPICS: 'SET_LATEST_TOPICS',
    SET_MY_LATEST_TOPICS: 'SET_MY_LATEST_TOPICS',
    SET_MY_CATEGORY_TOPICS: 'SET_MY_CATEGORY_TOPICS',
    SET_LATEST_CATEGORY_TOPICS: 'SET_LATEST_CATEGORY_TOPICS',
    SET_ACTIVE_TOPIC: 'SET_ACTIVE_TOPIC',
    SET_TOPICS: 'SET_TOPICS',
    SET_REPORTING_TOPIC_MESSAGE: 'SET_REPORTING_TOPIC_MESSAGE'
  },
  actions: {
    FETCH_MY_TOPICS: 'FETCH_MY_TOPICS',
    FETCH_LATEST_TOPICS: 'FETCH_LATEST_TOPICS',
    FETCH_MY_LATEST_TOPICS: 'FETCH_MY_LATEST_TOPICS',
    FETCH_MY_CATEGORY_TOPICS: 'FETCH_MY_CATEGORY_TOPICS',
    FETCH_LATEST_CATEGORY_TOPICS: 'FETCH_LATEST_CATEGORY_TOPICS',
    FETCH_CATEGORY_TOPICS: 'FETCH_CATEGORY_TOPICS',
    FETCH_TOPIC: 'FETCH_TOPIC',
    OPEN_MESSAGE_REPORT_DIALOG: 'OPEN_MESSAGE_REPORT_DIALOG'
  },
  getters: {}
};

export default types;
